function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

import color from "./color";
import font from "./font";
import { tickLabels, baseLabel } from "./svgLabel";
import { unit } from "./size";
export var colors = color;
export var labelStyles = _extends({}, baseLabel, font.light);
export var gridStyles = {
  stroke: colors.grid,
  strokeWidth: 1
};
export var xAxisStyles = {
  stroke: colors.gridDark,
  strokeWidth: 2,
  label: {
    bottom: _extends({}, baseLabel),
    top: _extends({}, baseLabel)
  }
};
export var yAxisStyles = {
  stroke: colors.grid,
  strokeWidth: 1,
  label: {
    left: _extends({}, baseLabel),
    right: _extends({}, baseLabel)
  }
};
export var xTickStyles = {
  stroke: colors.grid,
  length: +unit,
  label: {
    bottom: _extends({}, tickLabels.bottom),
    top: _extends({}, tickLabels.top)
  }
};
export var yTickStyles = {
  stroke: colors.grid,
  length: +unit,
  label: {
    left: _extends({}, tickLabels.left),
    right: _extends({}, tickLabels.right)
  }
};
export default {
  colors: colors,
  labelStyles: labelStyles,
  gridStyles: gridStyles,
  xAxisStyles: xAxisStyles,
  xTickStyles: xTickStyles,
  yAxisStyles: yAxisStyles,
  yTickStyles: yTickStyles
};